import { environment } from '@app/environments/environment';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface BankIdSignUpDto {
  email: string;
  phoneNumber: string;
}

export const apiRoot = `${environment.apiRoot}`;

@Injectable({
  providedIn: 'root',
})
export class BankIdService {
  private readonly isBrowser: boolean;

  /**
   * This class provides service of redirecting to BankId,
   */

  constructor(private httpClient: HttpClient, @Inject(PLATFORM_ID) platformId: string) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  getBankIdRedirect(): string {
    const referralCode = this.getItemFromStore('signUp.referralCode');
    const consultant = this.getItemFromStore('signUp.consultant');
    const clickId = this.getItemFromStore('signUp.clickId');
    const affiliateCode = this.getItemFromStore('signUp.affiliateCode');
    let params = new HttpParams();
    if (referralCode) params = params.set('referralCode', referralCode);
    if (consultant) params = params.set('consultant', consultant);
    if (affiliateCode) params = params.set('affiliateCode', affiliateCode);
    if (clickId) params = params.set('clickId', clickId);
    return apiRoot + '/frontend/bankid/bankid-redirect' + (params.toString() ? '?' + params.toString() : '');
  }

  getSignUpData(): Observable<BankIdSignUpDto> {
    return this.httpClient.get<BankIdSignUpDto>(apiRoot + '/frontend/bankid/get-signup-data');
  }

  getItemFromStore(key: string): string | null {
    if (!this.isBrowser) {
      return null;
    }

    return window.localStorage.getItem(key);
  }
}
